import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { Box, Button, Typography } from '@material-ui/core';

import BarberShopTitle from '../../components/BarberShopTitle';
import { useGetCompanyDetail } from '../../hooks/data/companies';
import { IOrderDataState, useOrder } from '../../hooks/order';
import { useCreateAppointment } from '../../hooks/data/appointments';
import { daysOfWeek } from '../../utils/constants';
import { HOME_URL } from '../../shared/environments';

type IParams = {
  slug: string;
};

const getWhatsappMessage = (
  number: string,
  orderData: IOrderDataState,
  appointmentId: string,
  companySlug: string,
) => {
  const message = `Olá. Sou ${
    orderData.customer_name
  } e reservei o dia ${orderData.day.format('DD/MM')}, das ${
    orderData.startTime
  } às ${orderData.endTime} para o serviço de ${orderData.service.service_name}
  
  Para excluir seu agendamento basta acessar o link abaixo: 
  ${HOME_URL}/parceiro/${companySlug}/agendamento/${appointmentId}/excluir  
  `;
  return `https://wa.me/55${number}?text=${encodeURI(message)}`;
};

const ConfirmAppointment: React.FC = () => {
  const params = useParams<IParams>();

  const { orderData } = useOrder();

  const createAppointment = useCreateAppointment({});

  const { data: companyData, status: companyDataStatus } = useGetCompanyDetail(
    params.slug,
  );

  const handleSubmit = useCallback(async () => {
    try {
      const response = await createAppointment.mutateAsync({
        customer_name: orderData.customer_name,
        customer_whatsapp: orderData.customer_whatsapp,
        start_time: orderData.startTime,
        end_time: orderData.endTime,
        service: orderData.service.id,
        date: orderData.day.format('DD-MM-yyyy'),
      });
      window.location.href = getWhatsappMessage(
        companyData?.cellphone ?? '',
        orderData,
        response.data.id!,
        companyData?.slug ?? '',
      );
    } catch (err) {
      console.log(err);
    }
  }, [companyData?.cellphone, companyData?.slug, createAppointment, orderData]);

  return (
    <Box
      width="100%"
      height="100vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="flex-start"
      padding={3}
      textAlign="start"
    >
      <Box width="100%">
        <BarberShopTitle title={companyData?.company_name ?? ''} />
        <Typography
          style={{ marginTop: '24px', display: 'block' }}
          variant="subtitle1"
        >
          Agradecemos a preferência.
        </Typography>
      </Box>
      <Typography variant="subtitle1">
        {`Você deseja agendar o serviço de ${
          orderData.service.service_name
        } para o dia ${orderData.day.format('DD/MM')} (${
          Object.values(daysOfWeek)[orderData.day.day()]
        }), das ${orderData.startTime} às ${orderData.endTime}?
        Confirme no botão abaixo.`}
      </Typography>

      <Box
        width="100%"
        marginTop="64px"
        marginBottom="40px"
        display="flex"
        justifyContent="center"
      >
        <Button onClick={handleSubmit} color="primary" variant="contained">
          Finalizar agendamento
        </Button>
      </Box>
    </Box>
  );
};

export default ConfirmAppointment;
